var _linearGradient, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFinance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_5",
    enableBackground: "new 0 0 64 64",
    height: 512,
    viewBox: "0 0 64 64",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 32,
    x2: 32,
    y1: 63,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9f2fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0bb1d3"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m34 15v-1c0-.551-.448-1-1-1h-2c-1.654 0-3-1.346-3-3v-3h3v-2h2v2c1.654 0 3 1.346 3 3h-2c0-.551-.448-1-1-1h-3v1c0 .551.448 1 1 1h2c1.654 0 3 1.346 3 3v3h-3v2h-2v-2c-1.654 0-3-1.346-3-3h2c0 .551.448 1 1 1zm-33 36c0-2.206 1.794-4 4-4h1v-20h-3v-5.586l18.035-10.1c.357-5.745 5.131-10.314 10.965-10.314s10.608 4.569 10.965 10.314l18.035 10.1v5.586h-3v20h1c2.206 0 4 1.794 4 4s-1.794 4-4 4c-.732 0-1.409-.212-2-.556v8.556h-50v-8.556c-.591.344-1.268.556-2 .556-2.206 0-4-1.794-4-4zm20 5c0-1.654-1.346-3-3-3s-3 1.346-3 3v5h6zm14 0c0-1.654-1.346-3-3-3s-3 1.346-3 3v5h6zm14 0c0-1.654-1.346-3-3-3s-3 1.346-3 3v5h6zm7-29h-4v20h4zm-42 0v20h14v-20zm16 20h4v-20h-4zm6 0h14v-20h-14zm6.877-33.443c-.438 3.071-2.141 5.735-4.572 7.443h17.863zm-19.877-1.557c0 4.962 4.037 9 9 9s9-4.038 9-9-4.037-9-9-9-9 4.038-9 9zm-1.877 1.557-13.291 7.443h17.863c-2.431-1.708-4.134-4.372-4.572-7.443zm-16.123 11.443h23 8 23v-2h-54zm3 22h4v-20h-4zm-5 4c0 1.103.897 2 2 2s2-.897 2-2h2v10h4v-5c0-2.757 2.243-5 5-5s5 2.243 5 5v5h4v-5c0-2.757 2.243-5 5-5s5 2.243 5 5v5h4v-5c0-2.757 2.243-5 5-5s5 2.243 5 5v5h4v-10h2c0 1.103.897 2 2 2s2-.897 2-2-.897-2-2-2h-23-8-23c-1.103 0-2 .897-2 2zm45-22v16h-10v-16zm-2 2h-6v12h6zm-30 14v-16h10v16zm2-2h6v-12h-6z",
    fill: "url(#SVGID_1_)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinance);
export default __webpack_public_path__ + "static/media/finance.20a7e22ec60c9f1dbe643e37b17b5413.svg";
export { ForwardRef as ReactComponent };